export const AppContentStatus = {
  None: null,
  NewContentAvailable: "NEW_CONTENT_AVAILABLE",
  NewContentInstalled: "NEW_CONTENT_INSTALLED",
  Error: "ERROR",
};